import { useEffect } from "react";
import { ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useLanguage } from "@/i18n/LanguageContext";
import { trackEvent } from "@/stats";
import { trackGAEvent } from "@/consent";
import { SITE } from "@/config";

export default function BookingModal({ open, onOpenChange }) {
  const { lang, t } = useLanguage();

  useEffect(() => {
    if (open) trackEvent("booking_click", { lang });
  }, [open, lang]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-cream sm:max-w-3xl max-h-[92vh] overflow-y-auto" data-testid="booking-modal">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">{t.booking.title}</DialogTitle>
          <DialogDescription>{t.booking.subtitle}</DialogDescription>
        </DialogHeader>

        {SITE.calendarUrl && (
          <iframe src={SITE.calendarUrl} title="calendar" className="w-full h-[440px] max-h-[52vh] rounded-xl border border-line" data-testid="booking-calendar-iframe" />
        )}

        {SITE.ifmvUrl && (
          <div className="mt-4 text-center">
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-muted2 mb-3">{t.booking.ifmv_or}</p>
            <a
              href={SITE.ifmvUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => { trackEvent("booking_ifmv_click", { lang }); trackGAEvent("booking_click", { language: lang, page_path: window.location.pathname, booking_provider: "IFMV", link_url: SITE.ifmvUrl }); }}
              className="inline-flex items-center gap-2 rounded-full border border-sage px-6 py-3 text-sm font-semibold text-sage transition-colors hover:bg-sage hover:text-white"
              data-testid="booking-ifmv-link"
            >
              {t.booking.ifmv_cta}
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
